import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CaretDown = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7143 9.60714C16.7143 9.77158 16.6542 9.91388 16.534 10.034L12.284 14.284C12.1639 14.4042 12.0216 14.4643 11.8571 14.4643C11.6927 14.4643 11.5504 14.4042 11.4302 14.284L7.18025 10.034C7.06008 9.91388 7 9.77158 7 9.60714C7 9.44271 7.06008 9.30041 7.18025 9.18025C7.30041 9.06008 7.44271 9 7.60714 9H16.1071C16.2716 9 16.4139 9.06008 16.534 9.18025C16.6542 9.30041 16.7143 9.44271 16.7143 9.60714Z"
        />
    </StarryUIIcon>
);
